import React from 'react';
import { GLOBAL_THEME_DEFAULT } from '_constants';
import { UI_Main } from 'ui/components/4-habitats/Main/Main';
import { UI_Article, UI_ArticleProps } from 'ui/components/4-habitats/Article/Article';
import { ModuleFeature } from 'features/Modules/DynamicModule/DynamicModuleFeature';
import { UI_Footer } from 'ui/components/4-habitats/Footer/Footer';
import { articleMapper, footerMapper } from 'helpers/mappers';
import { usePageContext } from 'application/contexts/PageContext';
import { useSiteContext } from 'application/contexts/SiteContext';
import { useDictionaryContext } from 'application/contexts/DictionaryContext';

export const ArticlePageFeature: React.FC<Content.ArticlePage> = (articlePage) => {
	const pageContext = usePageContext();
	const siteContext = useSiteContext();
	const globalTheme: string = siteContext.settings.globalTheme?.setTheme ?? GLOBAL_THEME_DEFAULT;
	const dictionary = useDictionaryContext();
	const footerArgs = footerMapper(pageContext.footer, globalTheme, dictionary);
	const { pageSections } = articlePage.properties ?? {};
	const articleProps = articleMapper(articlePage, globalTheme);

	return (
		<>
			<UI_Main>
				<UI_Article
					{...(articleProps as UI_ArticleProps)}
					eventDisplayButtonRight={articlePage?.properties?.eventDisplayButtonRight}
					showArticleAuthorsBio={articlePage?.properties.showArticleAuthorsBio}
					placeholderLabel={dictionary?.getValue('Form.PlaceholderLabel')}
				></UI_Article>
				{pageSections.map((pageSection, index) => (
					<ModuleFeature key={index} contentModule={pageSection} />
				))}
			</UI_Main>

			{footerArgs && <UI_Footer {...footerArgs} />}
		</>
	);
};
